import React, { useEffect, useState } from 'react';
import cookies from 'js-cookie';
import ZhuyunLogin from '@root/service/zhuyunLogin'

const Logout = ()=>{
  const [logout, setLogout] = useState(false)
  useEffect(()=>{
    (async ()=>{
      if(!cookies.get('token')){
        return
      }
      await ZhuyunLogin.serviceLogout()
      ZhuyunLogin.clearLoginInfo()
      setLogout(true)
    })()
  }, [])
  return <div>{ logout ? '已退出登录' : '未登录'}</div>
}


export default Logout



// WEBPACK FOOTER //
// ./src/view/logout/index.js